import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  CidadeDTO,
  CidadeResponseDTO,
} from '../../models/configuracoes/cidade.model';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CidadeService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<CidadeResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<CidadeResponseDTO>(patch);
  }

  getById<T>(url: string): Observable<CidadeDTO> {
    return this.apiService.read<CidadeDTO>(url);
  }

  post<T>(url: string, data: CidadeDTO): Observable<CidadeDTO> {
    return this.apiService.create<CidadeDTO>(url, data);
  }

  put<T>(url: string, data: CidadeDTO): Observable<CidadeDTO> {
    console.log(data);
    console.log(url);

    return this.apiService.update<CidadeDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
